import { render, staticRenderFns } from "./order-content.vue?vue&type=template&id=5a65c4b4&scoped=true&lang=pug"
import script from "./order-content.vue?vue&type=script&lang=js"
export * from "./order-content.vue?vue&type=script&lang=js"
import style0 from "./order-content.vue?vue&type=style&index=0&id=5a65c4b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65c4b4",
  null
  
)

export default component.exports